import CommonLocal from "../lib/commonLocal";
import {
  ADD_TO_FAV,
  ADD_TO_FAV_PODCAST,
  GET_INHOUSE_FAV_LIST,
  GET_INHOUSE_PLAYLIST,
  GET_PODCAST_FAV_LIST,
  GET_PODCAST_PLAYLIST,
  GET_INHOUSE,
  PODCAST,
  REMOVE_FROM_FAV,
  REMOVE_FROM_FAV_PODCAST,
  MOST_VIEWED_PODCASTS,
  TRENDING_PODCASTS,
  TAG_SEARCH,
  SEARCH_RESULTS,
} from "./constants";
import { publicActions } from "./publicSlice";
import { toast } from "react-hot-toast";
import { mediaActions } from "./mediaSlice";
import CommonAPI from "../lib/common";

//IN-HOUSE END USER //

export const getInHouseList = (searchQuery) => {
  const separator = GET_INHOUSE.split("?").length > 1 ? "&" : "?";

  return async (dispatch) => {
    try {
      dispatch(mediaActions.resetUnit('inhouse'));

      const response = await CommonLocal(
        `${GET_INHOUSE}${separator}${searchQuery}`
      );

      dispatch(mediaActions.getInHouseList({ response: response }));
      return response;
    } catch (error) {
      //dispatch(publicActions.isLoading(false));
      // console.log(error);
      //   if (error.response && error.response.data.message !== "") {
      //     dispatch(todoActions.alert(error.response.data.message));
      //   } else {
      //     dispatch(todoActions.alert("Something went wrong. Please try again."));
      //   }
    }
  };
};

export const getPodcastList = (searchQuery) => {
  const separator = PODCAST.split("?").length > 1 ? "&" : "?";

  return async (dispatch) => {
    try {
      dispatch(mediaActions.resetUnit({type:'podcast'}));

      const response = await CommonLocal(
        `${PODCAST}${separator}${searchQuery}`
      );
      dispatch(mediaActions.getPodcast({ response: response }));
      return response;
    } catch (error) {
      //dispatch(publicActions.isLoading(false));
      // console.log(error);
      //   if (error.response && error.response.data.message !== "") {
      //     dispatch(todoActions.alert(error.response.data.message));
      //   } else {
      //     dispatch(todoActions.alert("Something went wrong. Please try again."));
      //   }
    }
  };
};

// export const getInHouseList = (limit = 0, searchQuery="") => {
//   const separator = GET_INHOUSE.split("?").length > 1 ? "&" : "?";
//   const queryLimit = limit > 0 ? `${separator}limit=${limit}` : "";

//   return async (dispatch) => {
//     //dispatch(publicActions.isLoading(true));
//     try {
//       const response = await CommonLocal(`${GET_INHOUSE}${queryLimit}${searchQuery}`);
//       dispatch(mediaActions.getInHouseList({ response: response }));
//       //dispatch(publicActions.isLoading(false));
//       return response;
//     } catch (error) {
//       //dispatch(publicActions.isLoading(false));
//       //console.log(error);
//       //   if (error.response && error.response.data.message !== "") {
//       //     dispatch(todoActions.alert(error.response.data.message));
//       //   } else {
//       //     dispatch(todoActions.alert("Something went wrong. Please try again."));
//       //   }
//     }
//   };
// };

// export const getPodcastList = (limit = 0, searchQuery = "") => {
//   const separator = PODCAST.split("?").length > 1 ? "&" : "?";
//   const queryLimit = limit > 0 ? `${separator}limit=${limit}` : "";
//   return async (dispatch) => {
//     //dispatch(publicActions.isLoading(true));
//     try {
//       const response = await CommonLocal(
//         `${PODCAST}${queryLimit}${searchQuery}`
//       );
//       dispatch(mediaActions.getPodcast({ response: response }));
//       //dispatch(publicActions.isLoading(false));

//       return response;
//     } catch (error) {
//       //dispatch(publicActions.isLoading(false));
//       console.log(error);
//       //   if (error.response && error.response.data.message !== "") {
//       //     dispatch(todoActions.alert(error.response.data.message));
//       //   } else {
//       //     dispatch(todoActions.alert("Something went wrong. Please try again."));
//       //   }
//     }
//   };
// };

export const getSingleInHouse = (slug) => {
  return async (dispatch) => {
    // try {
    //   const response = await CommonLocal(GET_SINGLE_INHOUSE);
    //   dispatch(mediaActions.getSingleInHouse({ response: response }));
    //   return response;
    // } catch (error) {
    //   if (error.response && error.response.data.message !== "") {
    //     dispatch(publicActions.alert(error.response.data.message));
    //   } else {
    //     dispatch(
    //       publicActions.alert("Something went wrong. Please try again.")
    //     );
    //   }
    // }
  };
};

export const addToFavourite = (values) => {
  return async (dispatch) => {
    try {
      const response = await CommonLocal(ADD_TO_FAV, values, "POST");
      // toast.success(
      //   "In-house has been added to your favourites' list successfully."
      // );
      return response;
    } catch (error) {
      // console.log(error);

      // if (error.response && error.response.data.message !== "") {
      //   dispatch(ticketActions.alert(error.response.data.message));
      // } else {
      //   dispatch(ticketActions.alert("Something went wrong. Please try again."));
      // }
    }
  };
};
export const addToList = (values) => {
  return async (dispatch) => {
    //dispatch(publicActions.isLoading(true));
    try {
      const response = await CommonLocal(ADD_TO_FAV, values, "POST");

      toast.success(`${values.title} added to favourites`);

      //dispatch(publicActions.isLoading(false));
      return response;
    } catch (error) {
      //console.log(error);
      //dispatch(publicActions.isLoading(false));
      // if (error.response && error.response.data.message !== "") {
      //   dispatch(ticketActions.alert(error.response.data.message));
      // } else {
      //   dispatch(ticketActions.alert("Something went wrong. Please try again."));
      // }
    }
  };
};
export const addToViewed = (values) => {
  return async (dispatch) => {
    try {
      const response = await CommonLocal(ADD_TO_FAV, values, "POST");

      return response;
    } catch (error) {
      // console.log(error);

      // if (error.response && error.response.data.message !== "") {
      //   dispatch(ticketActions.alert(error.response.data.message));
      // } else {
      //   dispatch(ticketActions.alert("Something went wrong. Please try again."));
      // }
    }
  };
};

export const removeFromFavourite = (values) => {
  return async (dispatch) => {
    try {
      const response = await CommonLocal(REMOVE_FROM_FAV, values, "POST");

      // toast.success(
      //   "In-house has been removed from your favourites' list successfully."
      // );
      return response;
    } catch (error) {
      // console.log(error);
      // if (error.response && error.response.data.message !== "") {
      //   dispatch(ticketActions.alert(error.response.data.message));
      // } else {
      //   dispatch(ticketActions.alert("Something went wrong. Please try again."));
      // }
    }
  };
};
export const removeFromList = (values) => {
  return async (dispatch) => {
    //dispatch(publicActions.isLoading(true));
    try {
      const response = await CommonLocal(REMOVE_FROM_FAV, values, "POST");

      toast.success(`${values.title} removed from favourites`);

      //dispatch(publicActions.isLoading(false));
      return response;
    } catch (error) {
      // console.log(error);
      // dispatch(publicActions.isLoading(false));

      // if (error.response && error.response.data.message !== "") {
      //   dispatch(ticketActions.alert(error.response.data.message));
      // } else {
      //   dispatch(ticketActions.alert("Something went wrong. Please try again."));
      // }
    }
  };
};

export const getFavourites = (type = "inhouse") => {
  return async (dispatch) => {
    dispatch(publicActions.isLoading(true));
    try {
      let response;
      if (type === "podcast") {
        response = await CommonLocal(GET_PODCAST_FAV_LIST);
        dispatch(mediaActions.getPodcastFavList({ response: response }));
      } else {
        response = await CommonLocal(GET_INHOUSE_FAV_LIST);
        dispatch(mediaActions.getInHouseFavList({ response: response }));
      }

      dispatch(publicActions.isLoading(false));
      return response;
    } catch (error) {
      dispatch(publicActions.isLoading(false));
      // console.log(error);
      //   if (error.response && error.response.data.message !== "") {
      //     dispatch(todoActions.alert(error.response.data.message));
      //   } else {
      //     dispatch(todoActions.alert("Something went wrong. Please try again."));
      //   }
    }
  };
};
export const getPlaylist = (type = "inhouse") => {
  return async (dispatch) => {
    try {
      let response;
      if (type === "inhouse") {
        response = await CommonLocal(GET_INHOUSE_PLAYLIST);
        dispatch(mediaActions.getInHousePlaylist({ response: response }));
      } else {
        response = await CommonLocal(GET_PODCAST_PLAYLIST);
        dispatch(mediaActions.getPodcastPlaylist({ response: response }));
      }
      return response;
    } catch (error) {
      // console.log(error);
      //   if (error.response && error.response.data.message !== "") {
      //     dispatch(todoActions.alert(error.response.data.message));
      //   } else {
      //     dispatch(todoActions.alert("Something went wrong. Please try again."));
      //   }
    }
  };
};

//PODCAST END USER

export const addToFavouritePodcast = (values) => {
  return async (dispatch) => {
    //dispatch(publicActions.isLoading(true));
    try {
      const response = await CommonLocal(ADD_TO_FAV_PODCAST, values, "POST");

      // toast.success(
      //   "Podcast has been added to your favourites' list successfully."
      // );

      //dispatch(publicActions.isLoading(false));
      return response;
    } catch (error) {
      // console.log(error);
      //dispatch(publicActions.isLoading(false));

      // if (error.response && error.response.data.message !== "") {
      //   dispatch(ticketActions.alert(error.response.data.message));
      // } else {
      //   dispatch(ticketActions.alert("Something went wrong. Please try again."));
      // }
    }
  };
};
export const addToListPodcast = (values) => {
  return async (dispatch) => {
    //dispatch(publicActions.isLoading(true));
    try {
      const response = await CommonLocal(ADD_TO_FAV_PODCAST, values, "POST");

      toast.success(`${values.title} added to favourites`);

      //dispatch(publicActions.isLoading(false));
      return response;
    } catch (error) {
      // console.log(error);
      //dispatch(publicActions.isLoading(false));

      // if (error.response && error.response.data.message !== "") {
      //   dispatch(ticketActions.alert(error.response.data.message));
      // } else {
      //   dispatch(ticketActions.alert("Something went wrong. Please try again."));
      // }
    }
  };
};
export const addToViewedPodcast = (values) => {
  return async (dispatch) => {
    try {
      const response = await CommonLocal(ADD_TO_FAV_PODCAST, values, "POST");

      return response;
    } catch (error) {
      // console.log(error);

      // if (error.response && error.response.data.message !== "") {
      //   dispatch(ticketActions.alert(error.response.data.message));
      // } else {
      //   dispatch(ticketActions.alert("Something went wrong. Please try again."));
      // }
    }
  };
};

export const removeFromFavouritePodcast = (values) => {
  return async (dispatch) => {
    //dispatch(publicActions.isLoading(true));
    try {
      const response = await CommonLocal(
        REMOVE_FROM_FAV_PODCAST,
        values,
        "POST"
      );

      // toast.success(
      //   "Podcast has been removed from your favourites' list successfully."
      // );

      //dispatch(publicActions.isLoading(false));
      return response;
    } catch (error) {
      // console.log(error);
      //dispatch(publicActions.isLoading(false));

      // if (error.response && error.response.data.message !== "") {
      //   dispatch(ticketActions.alert(error.response.data.message));
      // } else {
      //   dispatch(ticketActions.alert("Something went wrong. Please try again."));
      // }
    }
  };
};
export const removeFromListPodcast = (values) => {
  return async (dispatch) => {
    //dispatch(publicActions.isLoading(true));
    try {
      const response = await CommonLocal(
        REMOVE_FROM_FAV_PODCAST,
        values,
        "POST"
      );

      toast.success(`${values.title} removed from favourites`);

      //dispatch(publicActions.isLoading(false));
      return response;
    } catch (error) {
      // console.log(error);
      //dispatch(publicActions.isLoading(false));

      // if (error.response && error.response.data.message !== "") {
      //   dispatch(ticketActions.alert(error.response.data.message));
      // } else {
      //   dispatch(ticketActions.alert("Something went wrong. Please try again."));
      // }
    }
  };
};

export const getFavouritePodcast = () => {
  return async (dispatch) => {
    dispatch(publicActions.isLoading(true));
    try {
      const response = await CommonLocal(GET_INHOUSE_FAV_LIST);
      dispatch(mediaActions.getInHouseFavList({ response: response }));
      dispatch(publicActions.isLoading(false));

      return response;
    } catch (error) {
      dispatch(publicActions.isLoading(false));
      // console.log(error);
      //   if (error.response && error.response.data.message !== "") {
      //     dispatch(todoActions.alert(error.response.data.message));
      //   } else {
      //     dispatch(todoActions.alert("Something went wrong. Please try again."));
      //   }
    }
  };
};
export const getPlaylistPodcast = () => {
  return async (dispatch) => {
    dispatch(publicActions.isLoading(true));
    try {
      const response = await CommonLocal(GET_INHOUSE_PLAYLIST);
      dispatch(mediaActions.getInHousePlaylist({ response: response }));
      dispatch(publicActions.isLoading(false));

      return response;
    } catch (error) {
      dispatch(publicActions.isLoading(false));
      // console.log(error);
      //   if (error.response && error.response.data.message !== "") {
      //     dispatch(todoActions.alert(error.response.data.message));
      //   } else {
      //     dispatch(todoActions.alert("Something went wrong. Please try again."));
      //   }
    }
  };
};

export const getTrendingPodcasts = (limit = 0) => {
  const separator = TRENDING_PODCASTS.split("?").length > 1 ? "&" : "?";
  const queryLimit = limit > 0 ? `${separator}limit=${limit}` : "";
  return async (dispatch) => {
    try {
      const response = await CommonLocal(`${TRENDING_PODCASTS}${queryLimit}`);
      dispatch(mediaActions.getTrendingPodcasts({ response: response }));
      return response;
    } catch (error) {
      // console.log(error);
      //   if (error.response && error.response.data.message !== "") {
      //     dispatch(todoActions.alert(error.response.data.message));
      //   } else {
      //     dispatch(todoActions.alert("Something went wrong. Please try again."));
      //   }
    }
  };
};

export const getMostViewedPodcasts = (limit = 0) => {
  const separator = MOST_VIEWED_PODCASTS.split("?").length > 1 ? "&" : "?";
  const queryLimit = limit > 0 ? `${separator}limit=${limit}` : "";
  return async (dispatch) => {
    try {
      const response = await CommonLocal(
        `${MOST_VIEWED_PODCASTS}${queryLimit}`
      );
      dispatch(mediaActions.getMostViewedPodcasts({ response: response }));
      return response;
    } catch (error) {
      if (error.response && error.response.data.message !== "") {
        dispatch(publicActions.alert(error.response.data.message));
      } else {
        dispatch(
          publicActions.alert(
            `Something went wrong. Please try again. ${error?.message}`
          )
        );
      }
    }
  };
};

export const getTagSearch = (id) => {
  return async (dispatch) => {
    try {
      const response = await CommonAPI(TAG_SEARCH + "?tagID=" + id);
      // console.log(response);
      dispatch(mediaActions.getTagSearch({ response: response }));
      return response;
    } catch (error) {
      // console.log(error);
    }
  };
};

export const getSearchResults = (keyword="") => {
  return async (dispatch) => {
    try {
      const response = await CommonAPI(
        SEARCH_RESULTS + "?searchKey=" + keyword
      );
      dispatch(mediaActions.setSearchResults({ response: response }));
      return response;
    } catch (error) {
      if (error.response && error.response.data.message !== "") {
        dispatch(publicActions.alert(error.response.data.message));
      } else {
        dispatch(
          publicActions.alert(
            `Something went wrong. Please try again. ${error?.message}`
          )
        );
      }
    }
  };
};
